export const isMobile = breakpoint => breakpoint === 0;
export const isNonMobile = breakpoint => breakpoint > 0;
export const isTablet = breakpoint => breakpoint === 1;
export const isHandheld = breakpoint => breakpoint <= 1;
export const isLarge = breakpoint => breakpoint === 2;
export const isExtraLarge = breakpoint => breakpoint > 2;

export const getBrowserWidth = () =>
  Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
export const getBrowserHeight = () =>
  Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  );
